import cn from 'classnames';
import { useState, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';

import Button from 'components/common/Button';
import Text from 'components/common/Text';

const Disclaimer = ({ message, textClassNames, buttonClassNames, viewPromoDisclaimerCopy }) => {
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const transitionRef = useRef();
  const disclaimerId = 'disclaimer-text';

  const promoText = viewPromoDisclaimerCopy ? 'promo ' : '';
  const viewDisclaimerText = `View ${promoText}disclaimer`;
  const closeDisclaimerText = `Close ${promoText}disclaimer`;

  return (
    <div>
      <Button
        type="button"
        className={cn(buttonClassNames, 'border-none bg-transparent pb-0 font-normal underline')}
        onClick={() => setShowDisclaimer(!showDisclaimer)}
        variation="Secondary"
        aria-expanded={showDisclaimer}
        aria-controls={disclaimerId}
      >
        {showDisclaimer ? closeDisclaimerText : viewDisclaimerText}
      </Button>
      <CSSTransition
        classNames={{
          enter: 'fadeInOut-enter scaleHeight-enter',
          enterActive: 'fadeInOut-enter-active scaleHeight-enter-active',
          exit: 'fadeInOut-exit scaleHeight-exit',
          exitActive: 'fadeInOut-exit-active scaleHeight-exit-active',
        }}
        in={showDisclaimer}
        timeout={500}
        unmountOnExit
        nodeRef={transitionRef}
      >
        <div ref={transitionRef} id={disclaimerId}>
          <Text
            brandStylesOverrides="textSm text-secondary pb-6"
            className={cn('h-full', textClassNames)}
            dangerouslySetInnerHTML={{ __html: message }}
          />
        </div>
      </CSSTransition>
    </div>
  );
};

Disclaimer.propTypes = {
  message: PropTypes.string.isRequired,
  textClassNames: PropTypes.string,
  buttonClassNames: PropTypes.string,
  viewPromoDisclaimerCopy: PropTypes.bool,
  buttonTextSizeClassName: PropTypes.string,
};

export default Disclaimer;
